export default __webpack_public_path__ + "static/media/company_active.2d699aeb.svg";